import React from 'react'
import { Badge, Tooltip } from 'antd'
import styled from 'styled-components'
import { TaskCounters } from '../../store/user_menu/interfaces'

interface TaskCountersBadgesProps {
  counters: TaskCounters | null
}

const CountersWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  line-height: 1;

  .ant-badge-count {
    box-shadow: 0 0 0 1px #fff;
  }
`

export const TaskCountersBadges = ({ counters }: TaskCountersBadgesProps) => {
  if (!counters) {
    return null
  }

  return (
    <CountersWrapper>
      <Tooltip title={`Задач на сегодня: ${counters.today}`}>
        <Badge count={counters.today} showZero color="#389e0d" overflowCount={99} />
      </Tooltip>
      <Tooltip title={`Просроченных задач: ${counters.overdue}`}>
        <Badge count={counters.overdue} showZero overflowCount={99} />
      </Tooltip>
    </CountersWrapper>
  )
}
